export default {
  methods: {
    inPickedIndex: function inPickedIndex(row) {
      var _this = this;

      if (!row || !Object.keys(row).length || !this.picked.length) return -1;
      return this.picked.findIndex(function (val) {
        return val[_this.keyField] === row[_this.keyField];
      });
    },
    inPicked: function inPicked(row) {
      return this.inPickedIndex(row) !== -1;
    },
    adjust: function adjust() {
      this.$refs.drop.adjust();
    },
    close: function close() {
      if (this.show) this.$refs.drop.visible();
    },
    inputFocus: function inputFocus() {
      var _this2 = this;

      if (!this.show || !this.isSearch) return;
      this.$nextTick(function () {
        if (_this2.isChrome() || _this2.isEdge()) _this2.$refs.search.focus({ preventScroll: true });else {
          var x = window.pageXOffset;var y = window.pageYOffset;
          _this2.$refs.search.focus();
          if (window.pageYOffset !== y) setTimeout(function () {
            window.scrollTo(x, y);
          }, 0);
        }
      });
    },
    isChrome: function isChrome() {
      return navigator.vendor !== undefined && navigator.vendor.indexOf('Google') !== -1;
    },
    isEdge: function isEdge() {
      return navigator.userAgent.indexOf('Edge') >= 0;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/mixins/util.js
// module id = 19
// module chunks = 0